import { render } from "./WithdrawnRequests.vue?vue&type=template&id=5643a064"
import script from "./WithdrawnRequests.vue?vue&type=script&lang=js"
export * from "./WithdrawnRequests.vue?vue&type=script&lang=js"

import "./WithdrawnRequests.vue?vue&type=style&index=0&id=5643a064&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__